import { FC } from "react";
import { Button, Text } from "@chakra-ui/react";

interface Props {
  term: number;
  isSelected: boolean;
  onSelect: () => void;
}

export const SbpTransferPageTermItem: FC<Props> = ({ term, isSelected, onSelect }) => {
  const text = term ? `${term} мес` : "";

  if (!text) {
    return null;
  }

  return (
    <Button
      w="65px"
      h="28px"
      bg={isSelected ? "brand.500" : "gray.75"}
      colorScheme="transparent"
      borderRadius="35px"
      pointerEvents={isSelected ? "none" : "auto"}
      onClick={onSelect}
    >
      <Text fontSize="12px" variant={isSelected ? "white" : "gray"}>
        {text}
      </Text>
    </Button>
  );
};
